// src/services/pdf/core/colors.ts
// Clinical and brand colour constants for PDF rendering.

export const PDF_COLORS = {
  // Clinical signal levels
  red: { r: 201, g: 124, b: 124 },       // #C97C7C
  amber: { r: 168, g: 127, b: 42 },      // #a87f2a
  green: { r: 108, g: 122, b: 82 },      // #6C7A52

  // Text
  textPrimary: { r: 28, g: 25, b: 23 },  // #1C1917
  textSecondary: { r: 120, g: 113, b: 108 }, // #78716c
  textMuted: { r: 168, g: 162, b: 158 }, // #a8a29e

  // Backgrounds
  bgLight: { r: 250, g: 250, b: 249 },   // #fafaf9
  bgGreenTint: { r: 240, g: 246, b: 228 }, // #f0f6e4
  bgRedTint: { r: 245, g: 232, b: 232 }, // #F5E8E8
  bgAmberTint: { r: 251, g: 243, b: 224 }, // #FBF3E0

  // Structural
  border: { r: 231, g: 229, b: 228 },    // #e7e5e4
  white: { r: 255, g: 255, b: 255 },

  // Brand
  brandPrimary: { r: 108, g: 122, b: 82 },  // #6C7A52
  brandLight: { r: 198, g: 216, b: 165 },   // #C6D8A5
} as const;

export type RGBColor = { r: number; g: number; b: number };
